// IE 2026 10 16 / ODOO-5800 (ЗП-20261016-2, поручение Игоря 16.10: «добавь в сегмент на вкладку с динамическим списком причин граф, показывающий связи
// статусов через причины; при клике по связи — делай выделенной строку в динамическом списке причин, соответствующую связи-причине»).
// Чистая геометрия графа переходов вкладки Transitions формы политики (components_core/AttrTransitionsGraph.vue): узлы = статусы STATUS-plan слева направо
// по порядку бэка (Not started → Autoplan → Draft → In review → Approved-1..3 → Approved; Cancelled / Frozen — нижний ряд справа), рёбра = причины (строки грида,
// id ребра = id записи WORKFLOW). Данные — record._doc.approval_transitions_graph бэка (approval_wiring.transitions_graph); без него — graphFromRows по строкам
// грида (порядок статусов и направление — здесь же). Выключатель fe.ux.transitionsGraph (дефолт ВКЛ; выкл — только грид). Тест: tests/unit/transitionsGraph.test.mjs
// IE 2026 10 16 / ODOO-5800 (уровни; поручение Игоря 16.10: «In review» один на все уровни — рёбра Submit/Approve/Recall ПМ, БЮМ, МД сходятся в одну точку»):
// узел с levels (бэк: review → [1, 2, 3]) раскладывается expandLevels на узел по уровню «In review → Approved by PM» (id review@k) между своим «статусом с» и
// approved-k; ребро с level k идёт в review@k, ребро без level (миграция ∅ → review, review → cancelled) — ко всем review@k копиями (key = id@…, id — строки
// грида). Тест: tests/unit/transitionsGraphLevels.test.mjs
// IE 2026 10 17 / ODOO-5800 (graph layout) (поручение Игоря 17.10 по скрину вкладки ЗАТВЕРДЖЕННЯ → ПЕРЕХОДИ: «дай возможность перетаскивать узлы; кнопка, которая расставляла бы их по умолчанию;
// перетащили и сохранили — сохранять этот порядок расстановки и именно его визуализировать в форме ячейки в блоке утверждения»): сохранённая расстановка —
// поле записи политики doc.approval.graph_layout = {<id узла>: {x, y}} в координатах svg вкладки (viewBox; узел 118 × 30/36, ключ пустого статуса — '~');
// layoutGraph(opts.layout) ставит узлы точно по ней (без автосдвига; viewBox начинается с x0/y0 = охват содержимого), рёбра считаются заново; пустое поле = авто.
// Блок ячейки получает layout в графе бэка (approval_v2.cell_block graph.layout) и масштабирует scaleLayout по ширине узла. Тест: tests/unit/transitionsGraphLayout.test.mjs
import { approvalTransitionKind } from '@/utils/approval'

export const FLAG = 'fe.ux.transitionsGraph'
export function transitionsGraphOn(setting) {
    try { return !(typeof setting === 'function' && setting(FLAG, true) === false) } catch (e) { return true }
}

// порядок статусов — как _STATUS_ORDER бэка (approval_wiring); неизвестные — в конец по алфавиту
export const STATUS_ORDER = ['', 'statusPlan-autoplan', 'statusPlan-draft', 'statusPlan-review', 'statusPlan-approved-1', 'statusPlan-approved-2',
    'statusPlan-approved-3', 'statusPlan-approved', 'statusPlan-cancelled', 'statusPlan-frozen']
const SIDE = new Set(['statusPlan-cancelled', 'statusPlan-frozen'])
const REVIEW = 'statusPlan-review'   // IE 2026 10 16 / ODOO-5800 (уровни)
const str = (v) => (v == null ? '' : String(v))
const statusOrder = (st) => { const i = STATUS_ORDER.indexOf(st); return i < 0 ? STATUS_ORDER.length : i }

// граф по строкам грида (бэк ещё без approval_transitions_graph): titleOf(statusId) — подпись узла (по умолчанию короткий код статуса)
export function graphFromRows(rows, titleOf) {
    const list = Array.isArray(rows) ? rows.filter(r => r && typeof r === 'object' && str(r.id)) : []
    const seen = []
    for (const r of list) for (const k of ['status_from', 'status_to']) { const st = str(r[k]); if (!seen.includes(st)) seen.push(st) }
    seen.sort((a, b) => statusOrder(a) - statusOrder(b) || (a < b ? -1 : a > b ? 1 : 0))
    const title = (st) => {
        const t_ = typeof titleOf === 'function' ? titleOf(st) : ''
        if (t_) return t_
        const short = st.replace(/^statusPlan-/, '').replace(/-/g, ' ')
        return short ? short.charAt(0).toUpperCase() + short.slice(1) : 'Not started'   // «Approved 1», «Autoplan» — пока бэк не дал подписи STATUS-plan
    }
    const names = (rr) => (Array.isArray(rr) ? rr : []).filter(x => x && str(x.role) && x.use !== false).map(x => str(x.title) || str(x.role)).join(', ')
    const lvl = (r) => (r.level == null || r.level === '' || !Number.isFinite(Number(r.level)) ? null : Number(r.level))
    // IE 2026 10 16 / ODOO-5800 (уровни): kind с учётом уровня ребра — отзыв review@k → approved-(k−1) назад (зеркало transition_kind бэка)
    const kind = (r) => {
        const k = approvalTransitionKind({ status_to: r.status_to }, str(r.status_from)), lv = lvl(r), m = /approved-(\d+)$/.exec(str(r.status_to))
        return (k === 'primary' && str(r.status_from) === REVIEW && lv != null && m && Number(m[1]) < lv) ? 'back' : k
    }
    const edges = list.map(r => ({ id: str(r.id), from: str(r.status_from), to: str(r.status_to), title: str(r.title), kind: kind(r),
        system: !!r.system, use: r.use !== false && r.in_use !== false, roles: names(r.roles), edit_roles: names(r.edit_roles), level: lvl(r) }))
    const levels = [...new Set(edges.filter(e => e.level != null && (e.from === REVIEW || e.to === REVIEW)).map(e => e.level))].sort((a, b) => a - b)
    return {
        nodes: seen.map((st, i) => ({ id: st, title: title(st), order: i, side: SIDE.has(st), ...(st === REVIEW && levels.length ? { levels } : {}) })),
        edges,
    }
}

// IE 2026 10 16 / ODOO-5800 (уровни): узел с levels (≥ 2) → узел на уровень: id `<status>@k`, подпись «<статус> → <approved-k>» (lines — две строки
// для svg), order — перед approved-k (нет такого узла — после исходного по k). Ребро с level k — в копию @k; без level / с чужим — ко всем копиям
// (key уникален: id@<с>><на>; id — по-прежнему id строки грида, по нему клик / выделение). Граф без levels — как есть (key = id)
export function expandLevels(graph) {
    const nodesIn = (graph && Array.isArray(graph.nodes) ? graph.nodes : []).filter(n => n && typeof n === 'object')
    const edgesIn = (graph && Array.isArray(graph.edges) ? graph.edges : []).filter(e => e && typeof e === 'object' && str(e.id))
    const split = new Map()
    for (const n of nodesIn) {
        const lv = [...new Set((Array.isArray(n.levels) ? n.levels : []).map(Number).filter(Number.isFinite))].sort((a, b) => a - b)
        if (lv.length >= 2) split.set(str(n.id), lv)
    }
    if (!split.size) return { nodes: nodesIn.map(n => ({ ...n })), edges: edgesIn.map(e => ({ ...e, key: str(e.key) || str(e.id) })) }
    const byId = new Map(nodesIn.map(n => [str(n.id), n]))
    const nodes = []
    for (const n of nodesIn) {
        const id = str(n.id), lv = split.get(id)
        if (!lv) { nodes.push({ ...n, order: Number(n.order) || 0 }); continue }
        for (const k of lv) {
            const tn = byId.get('statusPlan-approved-' + k)
            const tTitle = tn ? str(tn.title) : String(k)
            nodes.push({ id: id + '@' + k, base: id, level: k, title: str(n.title) + ' → ' + tTitle, lines: [str(n.title), '→ ' + tTitle],
                order: tn ? (Number(tn.order) || 0) - 0.5 : (Number(n.order) || 0) + k / 100, side: !!n.side })
        }
    }
    const ends = (id, level) => {
        const lv = split.get(id)
        if (!lv) return [id]
        const k = level == null || level === '' ? null : Number(level)
        return k != null && lv.includes(k) ? [id + '@' + k] : lv.map(x => id + '@' + x)
    }
    const edges = []
    for (const e of edgesIn) {
        const fr = ends(str(e.from), e.level), to = ends(str(e.to), e.level), many = fr.length * to.length > 1
        for (const f of fr) for (const t_ of to) edges.push({ ...e, from: f, to: t_, key: many ? str(e.id) + '@' + f + '>' + t_ : str(e.id) })
    }
    return { nodes, edges }
}

// граф бэка, если он есть и непустой; иначе — по строкам
export function pickGraph(graph, rows, titleOf) {
    if (graph && typeof graph === 'object' && Array.isArray(graph.nodes) && graph.nodes.length && Array.isArray(graph.edges)) return graph
    return graphFromRows(rows, titleOf)
}

// точка выхода из прямоугольника узла (центр cx, cy; размеры w × h) в сторону (tx, ty), с отступом pad
export function rectEdgePoint(cx, cy, w, h, tx, ty, pad = 2) {   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы, взаимное выделение, виды связей): export — общий движок с графом схемы v2 (utils/schemeGraphV2.js)
    const dx = tx - cx, dy = ty - cy
    if (!dx && !dy) return { x: cx, y: cy - h / 2 - pad }
    const sx = dx ? (w / 2 + pad) / Math.abs(dx) : Infinity, sy = dy ? (h / 2 + pad) / Math.abs(dy) : Infinity
    const s = Math.min(sx, sy)
    return { x: cx + dx * s, y: cy + dy * s }
}
const r1 = (v) => Math.round(v * 10) / 10
// стрелка (треугольник) в точке p по направлению от q к p
export function arrow(p, q, size = 7) {   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: граф схемы как переходы, взаимное выделение, виды связей): export — общий движок с графом схемы v2 (utils/schemeGraphV2.js)
    const dx = p.x - q.x, dy = p.y - q.y, len = Math.hypot(dx, dy) || 1, ux = dx / len, uy = dy / len
    const bx = p.x - ux * size, by = p.y - uy * size
    return [p, { x: bx - uy * size * 0.5, y: by + ux * size * 0.5 }, { x: bx + uy * size * 0.5, y: by - ux * size * 0.5 }].map(t => r1(t.x) + ',' + r1(t.y)).join(' ')
}

// РАСКЛАДКА. width — ширина контейнера (px); → { W, H, nodes: [{id, title, x, y, w, h, side, lines?}], edges: [{id, key, d, lx, ly, ax (стрелка), kind, system, use, title, loop}] }.
// Основной ряд — по горизонтали с равным шагом на всю ширину (минимум nodeW + 28, тогда W шире контейнера — SVG масштабируется viewBox-ом);
// боковые (cancelled / frozen) — нижний ряд, прижаты вправо. Рёбра вперёд (order «с» < «на») — дугами над рядом, назад — под рядом; соседи вперёд первым
// ребром — прямой стрелкой; несколько рёбер одной пары — веером (растущий изгиб); self-loop — петля над узлом (несколько — вложенные петли)
export function layoutGraph(graph, width, opts = {}) {
    const lay = normalizeLayout(opts.layout)   // IE 2026 10 17 / ODOO-5800 (graph layout): сохранённая расстановка — узлы точно по ней
    const ex = expandLevels(graph)   // IE 2026 10 16 / ODOO-5800 (уровни): узел по уровню; граф без levels — без изменений
    const nodesIn = ex.nodes, edgesIn = ex.edges
    const nodeW = opts.nodeW || 118, nodeH = opts.nodeH || (nodesIn.some(n => n.lines) ? 36 : 30), padX = opts.padX ?? 14, minStep = nodeW + 28
    if (!nodesIn.length) return null
    const byOrder = (a, b) => (a.order ?? 0) - (b.order ?? 0) || str(a.id).localeCompare(str(b.id))
    const main = nodesIn.filter(n => !n.side).sort(byOrder)
    const side = nodesIn.filter(n => n.side).sort(byOrder)
    const n = Math.max(main.length, 1)
    const avail = Math.max(Number(width) || 0, minStep * n) - 2 * padX
    const step = n > 1 ? Math.max(minStep, (avail - nodeW) / (n - 1)) : 0
    const W = n > 1 ? Math.round(2 * padX + nodeW + step * (n - 1)) : Math.max(Number(width) || 0, nodeW + 2 * padX)
    const pos = new Map()
    main.forEach((nd, i) => pos.set(str(nd.id), { x: padX + nodeW / 2 + step * i, y: 0, side: false, node: nd }))
    const sideY = nodeH + 54
    side.forEach((nd, i) => pos.set(str(nd.id), { x: W - padX - nodeW / 2 - step * (side.length - 1 - i), y: sideY, side: true, node: nd }))
    if (lay) for (const [id, p] of pos) { const q = lay[layoutKey(id)]; if (q) { p.x = q.x; p.y = q.y } }   // IE 2026 10 17 / ODOO-5800 (graph layout): нет узла в расстановке — авто
    const idx = new Map(main.map((nd, i) => [str(nd.id), i]))   // IE 2026 10 16 / ODOO-5800 (уровни): место в ряду (order дробный у узлов уровня)
    const order = (id) => idx.get(id) ?? 0
    // группы по неупорядоченной паре — веер
    const groups = new Map(), loops = new Map()
    for (const e of edgesIn) {
        const a = str(e.from), b = str(e.to)
        if (!pos.has(a) || !pos.has(b)) continue
        const key = a === b ? a : [a, b].sort().join('\u0001')
        const m = a === b ? loops : groups
        if (!m.has(key)) m.set(key, [])
        m.get(key).push(e)
    }
    // рёбра в боковой узел (cancelled / frozen) сходятся из всех статусов — концы раскладываются по верхней грани узла по x источника, не в одну точку
    const sideIn = new Map()   // id ребра → смещение конца по x
    for (const [, list] of groups) for (const e of list) { const b = pos.get(str(e.to)); if (b && b.side && !pos.get(str(e.from)).side) { if (!sideIn.has(str(e.to))) sideIn.set(str(e.to), []); sideIn.get(str(e.to)).push(e) } }
    const endDx = new Map()
    for (const [, list] of sideIn) {
        list.sort((x, y) => pos.get(str(x.from)).x - pos.get(str(y.from)).x || str(x.key).localeCompare(str(y.key)))
        const n_ = list.length, span = nodeW - 24
        list.forEach((e, i) => endDx.set(str(e.key), n_ > 1 ? -span / 2 + span * i / (n_ - 1) : 0))   // по key: копии ребра без уровня — свои концы
    }
    const edges = []
    let minY = -nodeH / 2, maxY = (side.length ? sideY : 0) + nodeH / 2
    let minX = Infinity, maxX = -Infinity   // IE 2026 10 17 / ODOO-5800 (graph layout): охват по x (подписи рёбер) — для viewBox при сохранённой расстановке
    if (lay) { minY = Infinity; maxY = -Infinity; for (const p of pos.values()) { minY = Math.min(minY, p.y - nodeH / 2); maxY = Math.max(maxY, p.y + nodeH / 2) } }
    for (const [, list] of groups) {
        let kf = 0, kb = 0   // IE 2026 10 16 / ODOO-5800 (уровни): веер считается по направлению — прямая соседям вперёд не зависит от места строки в гриде
        list.forEach((e) => {
            const a = pos.get(str(e.from)), b = pos.get(str(e.to))
            const forward = a.side === b.side ? order(str(e.from)) < order(str(e.to)) : !a.side   // в боковой узел — «вперёд» (дуга сверху не нужна: он ниже)
            const k = forward ? kf++ : kb++
            const adjacent = !a.side && !b.side && Math.abs(order(str(e.from)) - order(str(e.to))) === 1
            const len = Math.hypot(b.x - a.x, b.y - a.y) || 1
            let bend = (adjacent && forward && k === 0) ? 0 : (0.16 * len + 12 + 20 * k)
            if (a.side !== b.side) bend = 14 + 20 * k   // между рядами — лёгкий изгиб
            const sign = forward ? -1 : 1   // вперёд — над рядом, назад — под рядом
            // нормаль к отрезку (слева направо — вверх при sign < 0)
            const ux = (b.x - a.x) / len, uy = (b.y - a.y) / len
            const nx = -uy * sign * (a.x <= b.x ? 1 : -1), ny = ux * sign * (a.x <= b.x ? 1 : -1)
            const mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2
            const c = { x: mx + nx * bend, y: my + ny * bend }
            const p0 = rectEdgePoint(a.x, a.y, nodeW, nodeH, c.x, c.y)
            const dxEnd = endDx.get(str(e.key))
            const p2 = dxEnd != null ? { x: b.x + dxEnd, y: b.y - nodeH / 2 - 4 } : rectEdgePoint(b.x, b.y, nodeW, nodeH, c.x, c.y, 4)   // в боковой узел — свой вход по верхней грани
            const d = `M${r1(p0.x)},${r1(p0.y)} Q${r1(c.x)},${r1(c.y)} ${r1(p2.x)},${r1(p2.y)}`
            const lx = 0.25 * p0.x + 0.5 * c.x + 0.25 * p2.x, ly = 0.25 * p0.y + 0.5 * c.y + 0.25 * p2.y
            minY = Math.min(minY, ly - 14); maxY = Math.max(maxY, ly + 14)
            minX = Math.min(minX, lx - 40, c.x); maxX = Math.max(maxX, lx + 40, c.x)   // IE 2026 10 17 / ODOO-5800 (graph layout)
            edges.push({ id: str(e.id), key: str(e.key) || str(e.id), d, lx: r1(lx), ly: r1(ly), ax: arrow(p2, c), kind: str(e.kind) || 'plain', system: !!e.system, use: e.use !== false, title: str(e.title),
                from: str(e.from), to: str(e.to), roles: str(e.roles), edit_roles: str(e.edit_roles), loop: false, bend: r1(bend * sign) || 0 })
        })
    }
    for (const [id, list] of loops) {
        list.forEach((e, k) => {
            const a = pos.get(id), top = a.y - nodeH / 2 - 2, R = 30 + 18 * k
            const p0 = { x: a.x - 16, y: top }, p2 = { x: a.x + 16, y: top }
            const c1 = { x: a.x - 34 - 6 * k, y: top - R }, c2 = { x: a.x + 34 + 6 * k, y: top - R }
            const d = `M${r1(p0.x)},${r1(p0.y)} C${r1(c1.x)},${r1(c1.y)} ${r1(c2.x)},${r1(c2.y)} ${r1(p2.x)},${r1(p2.y)}`
            const ly = top - R * 0.75 - 2
            minY = Math.min(minY, ly - 14)
            minX = Math.min(minX, c1.x); maxX = Math.max(maxX, c2.x)   // IE 2026 10 17 / ODOO-5800 (graph layout)
            edges.push({ id: str(e.id), key: str(e.key) || str(e.id), d, lx: r1(a.x), ly: r1(ly), ax: arrow(p2, c2), kind: str(e.kind) || 'plain', system: !!e.system, use: e.use !== false, title: str(e.title),
                from: id, to: id, roles: str(e.roles), edit_roles: str(e.edit_roles), loop: true, bend: -R })
        })
    }
    // IE 2026 10 17 / ODOO-5800 (graph layout): при сохранённой расстановке координаты узлов — как сохранены (без сдвига); viewBox = охват содержимого (x0, y0, W, H), не уже контейнера
    if (lay) {
        for (const p of pos.values()) { minX = Math.min(minX, p.x - nodeW / 2); maxX = Math.max(maxX, p.x + nodeW / 2) }
        const x0 = Math.floor(minX - 8), y0 = Math.floor(minY - 8)
        const nodes = [...pos.entries()].map(([id, p]) => ({ id, title: str(p.node.title) || id, x: r1(p.x), y: r1(p.y), w: nodeW, h: nodeH, side: p.side,
            ...(Array.isArray(p.node.lines) ? { lines: p.node.lines.map(str), base: str(p.node.base), level: p.node.level } : {}) }))
        return { W: Math.max(Math.ceil(maxX + 8) - x0, Math.floor(Number(width) || 0) || 0), H: Math.ceil(maxY + 8) - y0, x0, y0, nodes, edges, layout: true }
    }
    const shift = -minY + 8
    const nodes = [...pos.entries()].map(([id, p]) => ({ id, title: str(p.node.title) || id, x: r1(p.x), y: r1(p.y + shift), w: nodeW, h: nodeH, side: p.side,
        ...(Array.isArray(p.node.lines) ? { lines: p.node.lines.map(str), base: str(p.node.base), level: p.node.level } : {}) }))
    for (const e of edges) {
        e.d = e.d.replace(/(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/g, (m_, x, y) => `${x},${r1(Number(y) + shift)}`)
        e.ax = e.ax.replace(/(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/g, (m_, x, y) => `${x},${r1(Number(y) + shift)}`)
        e.ly = r1(e.ly + shift)
    }
    return { W, H: Math.round(maxY + shift + 8), x0: 0, y0: 0, nodes, edges, layout: false }
}

// ---------- IE 2026 10 17 / ODOO-5800 (graph layout): сохранённая расстановка узлов ----------
export const LAYOUT_BINDING = 'doc.approval.graph_layout'   // поле записи политики: {<ключ узла>: {x, y}}; пусто — авто
export const layoutKey = (id) => (str(id) === '' ? '~' : str(id))   // ключ узла в расстановке (пустой статус «Not started» — '~': пустой ключ json не для всех хранилищ)
// расстановка из поля / payload: только конечные числа; пустая / не объект — null (= авто)
export function normalizeLayout(raw) {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null
    const out = {}
    for (const [k, v] of Object.entries(raw)) {
        if (!v || typeof v !== 'object') continue
        const x = Number(v.x), y = Number(v.y)
        if (Number.isFinite(x) && Number.isFinite(y)) out[layoutKey(k)] = { x: r1(x), y: r1(y) }
    }
    return Object.keys(out).length ? out : null
}
// расстановка по раскладке (все узлы — чтобы сохранённая не зависела от ширины контейнера): {ключ: {x, y}}; moved — поверх (узел, который тянут)
export function layoutOf(model, moved = null) {
    const out = {}
    for (const nd of (model && Array.isArray(model.nodes) ? model.nodes : [])) out[layoutKey(nd.id)] = { x: r1(nd.x), y: r1(nd.y) }
    if (moved && typeof moved === 'object') for (const [k, v] of Object.entries(normalizeLayout(moved) || {})) out[k] = v
    return out
}
// авторасстановка (без сохранённой): та же layoutGraph без opts.layout
export function defaultLayout(graph, width, opts = {}) {
    const o = { ...opts }; delete o.layout
    return layoutOf(layoutGraph(graph, width, o))
}
// масштаб сохранённой расстановки под другой размер узла (компактный граф формы ячейки: 96 / 118)
export function scaleLayout(layout, k) {
    const lay = normalizeLayout(layout), f = Number(k)
    if (!lay || !Number.isFinite(f) || f <= 0) return lay
    const out = {}
    for (const [id, p] of Object.entries(lay)) out[id] = { x: r1(p.x * f), y: r1(p.y * f) }
    return out
}
// точка svg по событию указателя: dx/dy пикселей → единицы viewBox (масштаб по ширине svg; preserveAspectRatio meet — он же по высоте)
export function svgScale(model, clientWidth) {
    const w = Number(clientWidth) || 0
    return model && model.W && w > 0 ? model.W / w : 1
}

// короткая подпись ребра для svg: обрезка по числу символов (полная — в карточке наведения)
export function shortLabel(s, max = 22) {
    const t_ = str(s).trim()
    return t_.length <= max ? t_ : t_.slice(0, Math.max(1, max - 1)).trimEnd() + '…'
}

// ---------- IE 2026 10 16 / ODOO-5800 (ЗП-20261016-2, блок v2 формы ячейки; поручение Игоря 16.10: «граф связей, как на вкладке Transitions, с выделением причины и статуса,
// в котором мы сейчас находимся») — компактный граф формы ячейки (components/widgets/CellTransitionsGraph.vue) на той же раскладке layoutGraph ----------
// подсветка по раскладке: current — узлы текущего статуса (узел уровня review@k — по base и уровню; без уровня — все копии), edge — все копии ребра current_edge,
// avail — рёбра, доступные пользователю сейчас (id в available: клик = команда); остальные рёбра приглушены. Тест: tests/unit/approvalV2Block.test.mjs
// IE 2026 10 16 / ODOO-5800 (ЗП-20261016-2, проверка dev02 22:19 п.1: у единицы review узел не выделялся): level — ДОСТИГНУТЫЙ уровень единицы (approval_v2.level бэка:
// 0 — ничего не утверждено), а узел уровня review@k — «на согласовании → approved-k», поэтому текущий узел единицы review уровня L — review@(L+1); нет такой копии —
// все копии. Копии ребра без уровня (миграция ∅ → review, review → cancelled — по одной на review@k): текущее / доступное — только копии при текущем узле, если такие есть
export function graphHighlight(layout, opts = {}) {
    const nodes = new Set(), edges = new Set(), avail = new Set()
    if (!layout || !Array.isArray(layout.nodes)) return { nodes, edges, avail }
    const cur = str(opts.currentStatus), curEdge = str(opts.currentEdge)
    const level = opts.level == null || opts.level === '' || !Number.isFinite(Number(opts.level)) ? null : Number(opts.level)
    const av = opts.available instanceof Set ? opts.available : new Set(Array.isArray(opts.available) ? opts.available.map(str) : [])
    const copies = []
    for (const nd of layout.nodes) {
        const id = str(nd.id)
        if (!cur) continue
        if (id === cur) nodes.add(id)
        else if (str(nd.base) === cur) copies.push(nd)
    }
    if (copies.length) {
        const want = level === null ? null : level + 1
        const hit = want === null ? [] : copies.filter(nd => Number(nd.level) === want)
        for (const nd of (hit.length ? hit : copies)) nodes.add(str(nd.id))
    }
    const list = Array.isArray(layout.edges) ? layout.edges : []
    const byId = new Map()
    for (const e of list) { const id = str(e.id); if (!byId.has(id)) byId.set(id, []); byId.get(id).push(e) }
    // копии ребра (одна строка грида → несколько рёбер review@k): при текущем узле — только они, иначе все
    const pick = (id) => {
        const all = byId.get(id) || []
        const near = nodes.size ? all.filter(e => nodes.has(str(e.from)) || nodes.has(str(e.to))) : []
        return near.length ? near : all
    }
    if (curEdge) for (const e of pick(curEdge)) edges.add(str(e.key) || str(e.id))
    for (const id of av) for (const e of pick(str(id))) avail.add(str(e.key) || str(e.id))
    return { nodes, edges, avail }
}
// высота компактного svg: вся раскладка целиком в полосе не выше maxH (масштаб viewBox-ом), не ниже minH
export function compactHeight(layout, width, maxH = 160, minH = 60) {
    if (!layout || !layout.W || !layout.H) return 0
    const w = Number(width) || layout.W
    const h = Math.round(layout.H * Math.min(1, w / layout.W))
    return Math.max(minH, Math.min(maxH, h))
}
